/*
 * Add necessary utility function to the prototype of Javascript object like Array, String, Object
 */
'use strict';

/**
 * Helper for formatting the string.
 "My name is {name} and college name is {collegeName}".format({name: 'Piyush', college: 'NIT, Surat'}) will produce
 My name is Piyush and college name is NIT,Surat
 */
String.prototype.format = function () {
  var str = this.toString();
  if (!arguments.length) return str;
  var args = typeof arguments[0];
  var isNotAUrl = arguments[1];
  args = 'string' == args || 'number' == args ? arguments : arguments[0];
  for (var arg in args) {
    var replace = args[arg] != null ? args[arg] : '';
    if (!isNotAUrl) {
      //It is required specially for titles which are having '&' in the text. If we do not encode those then '&'
      //will be treated as query param separator.
      replace = encodeURIComponent(replace);
    }
    str = str.replace(RegExp('\\{' + arg + '\\}', 'gi'), replace);
  }
  return str;
};

/**
 * Check all the possible condition for a string being an empty string.392
 * undefined, null and length ==0
 */
String.prototype.isEmpty = function () {
  var isEmpty = false;
  if (this == null || this == undefined) {
    isEmpty = true;
  } else if (this.trim().length == 0) {
    isEmpty = true;
  } else if (this.trim() == 'null' || this.trim() == 'undefined') {
    isEmpty = true;
  }
  return isEmpty;
};

/**
 * Replaces all the instances of "from" to "to"
 * @param from
 * @param to
 */
String.prototype.replaceAll = function (from, to) {
  return this ? this.replace(/from/g, to) : this;
};

String.prototype.notEmpty = function () {
  return !this.isEmpty();
};

Array.prototype.notEmpty = function () {
  return this.length > 0;
};

Array.prototype.isEmpty = function () {
  return !this.notEmpty();
};

String.prototype.hashCode = function () {
  var hash = 0,
    i,
    chr,
    len;
  if (this.length === 0) return hash;
  for (i = 0, len = this.length; i < len; i++) {
    chr = this.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  if (hash < 0) {
    hash = hash * -1;
  }
  return hash;
};

String.prototype.capitalized = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.capSentence = function () {
  const strimedString = this.replace(/-/g, ' ');
  const wordsArray = strimedString.toLowerCase().split(' ');
  const capsArray = wordsArray.map(function (word) {
    return word[0].toUpperCase() + word.slice(1);
  });
  return capsArray.join(' ');
};

//Add a polyfill for isArray method
if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

Array.prototype.append = function (anotherArray) {
  this.push.apply(this, anotherArray);
};
